"use client";

import React from "react";
import { SlideProps } from "@/components/Slider/Slider.interface";
import useSliderContext from "@/components/Slider/Slider.context";
import styles from "./Slider.module.scss";

const Slide: React.FC<SlideProps> = ({ children, index, activeClass = "", className = "" }) => {
  const { currentIndex, slidesToShow, columnGap, isLastSlide, totalSlides, isCircular } = useSliderContext();
  const activeIndexes: number[] = Array.from({ length: slidesToShow }, (_, i) =>
    isLastSlide ? totalSlides - i - 1 : currentIndex + i
  );
  const isActive: boolean = activeIndexes.includes(index);
  const isPrevSlide: boolean = currentIndex === index - 1;
  const isBehindPrevSlide: boolean = currentIndex <= index - 2;

  return (
    <div
      style={{
        paddingLeft: columnGap / 2,
        paddingRight: columnGap / 2,
        minWidth: `${100 / slidesToShow}%`,
        maxWidth: `${100 / slidesToShow}%`,
      }}
      className={`${styles.slide} ${isCircular ? styles.circularSlide : ""}  ${className} ${isActive ? `${styles.active} ${activeClass}` : ""}  ${isPrevSlide ? styles.prevSlide : ""} ${isBehindPrevSlide ? styles.behindPrevSlide : ""}`}
    >
      {children}
    </div>
  );
};

Slide.displayName = "Slide";

export default Slide;
